export const footerLinks = {
  'ge-ru': [
    {
      title: 'Популярные направления',
      items: [
        {
          href: 'https://ge.wingie.com/ru/flights/to-tbilisi/',
          title: 'Тбилиси',
        },
        {
          href: 'https://ge.wingie.com/ru/flights/to-batumi/',
          title: 'Батуми',
        },
        {
          href: 'https://ge.wingie.com/ru/flights/to-kutaisi/',
          title: 'Кутаиси',
        },
        {
          href: 'https://ge.wingie.com/ru/flights/to-moscow/',
          title: 'Москва',
        },
        {
          href: 'https://ge.wingie.com/ru/flights/to-istanbul/',
          title: 'Стамбул',
        },
        {
          href: 'https://ge.wingie.com/ru/flights/to-baku/',
          title: 'Баку',
        },
      ],
    },
    {
      title: 'Популярные страны',
      items: [
        {
          href: 'https://ge.wingie.com/ru/flights/tr-turkey/',
          title: 'Турция',
        },
        {
          href: 'https://ge.wingie.com/ru/flights/ru-russia/',
          title: 'Россия',
        },
        {
          href: 'https://ge.wingie.com/ru/flights/az-azerbaijan/',
          title: 'Азербайджан',
        },
        {
          href: 'https://ge.wingie.com/ru/flights/am-armenia/',
          title: 'Армения',
        },
        {
          href: 'https://ge.wingie.com/ru/flights/ae-united-arab-emirates/',
          title: 'ОАЭ',
        },
        {
          href: 'https://ge.wingie.com/ru/flights/de-germany/',
          title: 'Германия',
        },
      ],
    },
    {
      title: 'Популярные авиакомпании',
      items: [
        {
          href: 'https://ge.wingie.com/ru/flights/airlines/georgian-airways/',
          title: 'Georgian Airways',
        },
        {
          href: 'https://ge.wingie.com/ru/flights/airlines/turkish-airlines/',
          title: 'Turkish Airlines',
        },
        {
          href: 'https://ge.wingie.com/ru/flights/airlines/flydubai/',
          title: 'flydubai',
        },
        {
          href: 'https://ge.wingie.com/ru/flights/airlines/wizz-air/',
          title: 'Wizz Air',
        },
        {
          href: 'https://ge.wingie.com/ru/flights/airlines/pegasus/',
          title: 'Pegasus',
        },
        {
          href: 'https://ge.wingie.com/ru/flights/airlines/lufthansa/',
          title: 'Lufthansa',
        },
      ],
    },
  ],
  'ge-en': [
    {
      title: 'Top Destinations',
      items: [
        {
          href: 'https://ge.wingie.com/en/flights/to-tbilisi/',
          title: 'Tbilisi',
        },
        {
          href: 'https://ge.wingie.com/en/flights/to-batumi/',
          title: 'Batumi',
        },
        {
          href: 'https://ge.wingie.com/en/flights/to-kutaisi/',
          title: 'Kutaisi',
        },
        {
          href: 'https://ge.wingie.com/en/flights/to-moscow/',
          title: 'Moscow',
        },
        {
          href: 'https://ge.wingie.com/en/flights/to-istanbul/',
          title: 'Istanbul',
        },
        {
          href: 'https://ge.wingie.com/en/flights/to-baku/',
          title: 'Baku',
        },
      ],
    },
    {
      title: 'Popular Countries',
      items: [
        {
          href: 'https://ge.wingie.com/en/flights/tr-turkey/',
          title: 'Turkey',
        },
        {
          href: 'https://ge.wingie.com/en/flights/ru-russia/',
          title: 'Russia',
        },
        {
          href: 'https://ge.wingie.com/en/flights/az-azerbaijan/',
          title: 'Azerbaijan',
        },
        {
          href: 'https://ge.wingie.com/en/flights/am-armenia/',
          title: 'Armenia',
        },
        {
          href: 'https://ge.wingie.com/en/flights/ae-united-arab-emirates/',
          title: 'United Arab Emirates',
        },
        {
          href: 'https://ge.wingie.com/en/flights/de-germany/',
          title: 'Germany',
        },
      ],
    },
    {
      title: 'Popular Airlines',
      items: [
        {
          href: 'https://ge.wingie.com/en/flights/airlines/georgian-airways/',
          title: 'Georgian Airways',
        },
        {
          href: 'https://ge.wingie.com/en/flights/airlines/turkish-airlines/',
          title: 'Turkish Airlines',
        },
        {
          href: 'https://ge.wingie.com/en/flights/airlines/flydubai/',
          title: 'flydubai',
        },
        {
          href: 'https://ge.wingie.com/en/flights/airlines/wizz-air/',
          title: 'Wizz Air',
        },
        {
          href: 'https://ge.wingie.com/en/flights/airlines/pegasus/',
          title: 'Pegasus',
        },
        {
          href: 'https://ge.wingie.com/en/flights/airlines/lufthansa/',
          title: 'Lufthansa',
        },
      ],
    },
  ],
  'ge-ar': [
    {
      title: 'أفضل الوجهات',
      items: [
        {
          href: 'https://ge.wingie.com/ar/flights/to-tbilisi/',
          title: 'تبليسي',
        },
        {
          href: 'https://ge.wingie.com/ar/flights/to-batumi/',
          title: 'باتومي',
        },
        {
          href: 'https://ge.wingie.com/ar/flights/to-kutaisi/',
          title: 'كوتايسي',
        },
        {
          href: 'https://ge.wingie.com/ar/flights/to-moscow/',
          title: 'موسكو',
        },
        {
          href: 'https://ge.wingie.com/ar/flights/to-istanbul/',
          title: 'إسطنبول',
        },
        {
          href: 'https://ge.wingie.com/ar/flights/to-baku/',
          title: 'باكو',
        },
      ],
    },
    {
      title: 'الدول الشعبية',
      items: [
        {
          href: 'https://ge.wingie.com/ar/flights/tr-turkey/',
          title: 'تركيا',
        },
        {
          href: 'https://ge.wingie.com/ar/flights/ru-russia/',
          title: 'روسيا',
        },
        {
          href: 'https://ge.wingie.com/ar/flights/az-azerbaijan/',
          title: 'أذربيجان',
        },
        {
          href: 'https://ge.wingie.com/ar/flights/am-armenia/',
          title: 'أرمينيا',
        },
        {
          href: 'https://ge.wingie.com/ar/flights/ae-united-arab-emirates/',
          title: 'الإمارات العربية المتحدة',
        },
        {
          href: 'https://ge.wingie.com/ar/flights/de-germany/',
          title: 'ألمانيا',
        },
      ],
    },
    {
      title: 'شركات الطيران الشعبية',
      items: [
        {
          href: 'https://ge.wingie.com/ar/flights/airlines/georgian-airways/',
          title: 'الخطوط الجوية الجورجية',
        },
        {
          href: 'https://ge.wingie.com/ar/flights/airlines/turkish-airlines/',
          title: 'الخطوط الجوية التركية',
        },
        {
          href: 'https://ge.wingie.com/ar/flights/airlines/flydubai/',
          title: 'فلاي دبي',
        },
        {
          href: 'https://ge.wingie.com/ar/flights/airlines/wizz-air/',
          title: 'ويز إير',
        },
        {
          href: 'https://ge.wingie.com/ar/flights/airlines/pegasus/',
          title: 'بيجاسوس',
        },
        {
          href: 'https://ge.wingie.com/ar/flights/airlines/lufthansa/',
          title: 'لوفتهانزا',
        },
      ],
    },
  ],
  'ge-de': [
    {
      title: 'Top-Destinationen',
      items: [
        {
          href: 'https://ge.wingie.com/de/fluge/nach-tiflis/',
          title: 'Tiflis',
        },
        {
          href: 'https://ge.wingie.com/de/fluge/nach-batumi/',
          title: 'Batumi',
        },
        {
          href: 'https://ge.wingie.com/de/fluge/nach-kutaisi/',
          title: 'Kutaisi',
        },
        {
          href: 'https://ge.wingie.com/de/fluge/nach-moskau/',
          title: 'Moskau',
        },
        {
          href: 'https://ge.wingie.com/de/fluge/nach-istanbul/',
          title: 'Istanbul',
        },
        {
          href: 'https://ge.wingie.com/de/fluge/nach-baku/',
          title: 'Baku',
        },
      ],
    },
    {
      title: 'Beliebte Länder',
      items: [
        {
          href: 'https://ge.wingie.com/de/fluge/tr-turkei/',
          title: 'Türkei',
        },
        {
          href: 'https://ge.wingie.com/de/fluge/ru-russland/',
          title: 'Russland',
        },
        {
          href: 'https://ge.wingie.com/de/fluge/az-aserbaidschan/',
          title: 'Aserbaidschan',
        },
        {
          href: 'https://ge.wingie.com/de/fluge/am-armenien/',
          title: 'Armenien',
        },
        {
          href: 'https://ge.wingie.com/de/fluge/ae-vereinigte-arabische-emirate/',
          title: 'Vereinigte Arabische Emirate',
        },
        {
          href: 'https://ge.wingie.com/de/fluge/de-deutschland/',
          title: 'Deutschland',
        },
      ],
    },
    {
      title: 'Beliebte Fluggesellschaften',
      items: [
        {
          href: 'https://ge.wingie.com/de/fluge/fluggesellschaften/georgian-airways/',
          title: 'Georgian Airways',
        },
        {
          href: 'https://ge.wingie.com/de/fluge/fluggesellschaften/turkish-airlines/',
          title: 'Turkish Airlines',
        },
        {
          href: 'https://ge.wingie.com/de/fluge/fluggesellschaften/flydubai/',
          title: 'flydubai',
        },
        {
          href: 'https://ge.wingie.com/de/fluge/fluggesellschaften/wizz-air/',
          title: 'Wizz Air',
        },
        {
          href: 'https://ge.wingie.com/de/fluge/fluggesellschaften/pegasus/',
          title: 'Pegasus',
        },
        {
          href: 'https://ge.wingie.com/de/fluge/fluggesellschaften/lufthansa/',
          title: 'Lufthansa',
        },
      ],
    },
  ],
  'ge-es': [
    {
      title: 'Destinos principales',
      items: [
        {
          href: 'https://ge.wingie.com/es/vuelos/a-tbilisi/',
          title: 'Tbilisi',
        },
        {
          href: 'https://ge.wingie.com/es/vuelos/a-batumi/',
          title: 'Batumi',
        },
        {
          href: 'https://ge.wingie.com/es/vuelos/a-kutaisi/',
          title: 'Kutaisi',
        },
        {
          href: 'https://ge.wingie.com/es/vuelos/a-moscu/',
          title: 'Moscú',
        },
        {
          href: 'https://ge.wingie.com/es/vuelos/a-estambul/',
          title: 'Estambul',
        },
        {
          href: 'https://ge.wingie.com/es/vuelos/a-baku/',
          title: 'Bakú',
        },
      ],
    },
    {
      title: 'Países populares',
      items: [
        {
          href: 'https://ge.wingie.com/es/vuelos/tr-turquia/',
          title: 'Turquía',
        },
        {
          href: 'https://ge.wingie.com/es/vuelos/ru-rusia/',
          title: 'Rusia',
        },
        {
          href: 'https://ge.wingie.com/es/vuelos/az-azerbaiyan/',
          title: 'Azerbaiyán',
        },
        {
          href: 'https://ge.wingie.com/es/vuelos/am-armenia/',
          title: 'Armenia',
        },
        {
          href: 'https://ge.wingie.com/es/vuelos/ae-emiratos-arabes-unidos/',
          title: 'Emiratos Árabes Unidos',
        },
        {
          href: 'https://ge.wingie.com/es/vuelos/de-alemania/',
          title: 'Alemania',
        },
      ],
    },
    {
      title: 'Aerolíneas populares',
      items: [
        {
          href: 'https://ge.wingie.com/es/vuelos/aerolineas/georgian-airways/',
          title: 'Georgian Airways',
        },
        {
          href: 'https://ge.wingie.com/es/vuelos/aerolineas/turkish-airlines/',
          title: 'Turkish Airlines',
        },
        {
          href: 'https://ge.wingie.com/es/vuelos/aerolineas/flydubai/',
          title: 'flydubai',
        },
        {
          href: 'https://ge.wingie.com/es/vuelos/aerolineas/wizz-air/',
          title: 'Wizz Air',
        },
        {
          href: 'https://ge.wingie.com/es/vuelos/aerolineas/pegasus/',
          title: 'Pegasus',
        },
        {
          href: 'https://ge.wingie.com/es/vuelos/aerolineas/lufthansa/',
          title: 'Lufthansa',
        },
      ],
    },
  ],
  'ge-it': [
    {
      title: 'Destinazioni principali',
      items: [
        {
          href: 'https://ge.wingie.com/it/flights/to-tbilisi/',
          title: 'Tbilisi',
        },
        {
          href: 'https://ge.wingie.com/it/flights/to-batumi/',
          title: 'Batumi',
        },
        {
          href: 'https://ge.wingie.com/it/flights/to-kutaisi/',
          title: 'Kutaisi',
        },
        {
          href: 'https://ge.wingie.com/it/flights/to-moscow/',
          title: 'Mosca',
        },
        {
          href: 'https://ge.wingie.com/it/flights/to-istanbul/',
          title: 'Istanbul',
        },
        {
          href: 'https://ge.wingie.com/it/flights/to-baku/',
          title: 'Baku',
        },
      ],
    },
    {
      title: 'Paesi popolari',
      items: [
        {
          href: 'https://ge.wingie.com/it/flights/tr-turkey/',
          title: 'Turchia',
        },
        {
          href: 'https://ge.wingie.com/it/flights/ru-russia/',
          title: 'Russia',
        },
        {
          href: 'https://ge.wingie.com/it/flights/az-azerbaijan/',
          title: 'Azerbaigian',
        },
        {
          href: 'https://ge.wingie.com/it/flights/am-armenia/',
          title: 'Armenia',
        },
        {
          href: 'https://ge.wingie.com/it/flights/ae-united-arab-emirates/',
          title: 'Emirati Arabi Uniti',
        },
        {
          href: 'https://ge.wingie.com/it/flights/de-germany/',
          title: 'Germania',
        },
      ],
    },
    {
      title: 'Compagnie aeree popolari',
      items: [
        {
          href: 'https://ge.wingie.com/it/flights/airlines/georgian-airways/',
          title: 'Georgian Airways',
        },
        {
          href: 'https://ge.wingie.com/it/flights/airlines/turkish-airlines/',
          title: 'Turkish Airlines',
        },
        {
          href: 'https://ge.wingie.com/it/flights/airlines/flydubai/',
          title: 'flydubai',
        },
        {
          href: 'https://ge.wingie.com/it/flights/airlines/wizz-air/',
          title: 'Wizz Air',
        },
        {
          href: 'https://ge.wingie.com/it/flights/airlines/pegasus/',
          title: 'Pegasus',
        },
        {
          href: 'https://ge.wingie.com/it/flights/airlines/lufthansa/',
          title: 'Lufthansa',
        },
      ],
    },
  ],
  'ge-fr': [
    {
      title: 'Destinations principales',
      items: [
        {
          href: 'https://ge.wingie.com/fr/flights/to-tbilisi/',
          title: 'Tbilissi',
        },
        {
          href: 'https://ge.wingie.com/fr/flights/to-batumi/',
          title: 'Batoumi',
        },
        {
          href: 'https://ge.wingie.com/fr/flights/to-kutaisi/',
          title: 'Koutaïssi',
        },
        {
          href: 'https://ge.wingie.com/fr/flights/to-moscow/',
          title: 'Moscou',
        },
        {
          href: 'https://ge.wingie.com/fr/flights/to-istanbul/',
          title: 'Istanbul',
        },
        {
          href: 'https://ge.wingie.com/fr/flights/to-baku/',
          title: 'Bakou',
        },
      ],
    },
    {
      title: 'Pays populaires',
      items: [
        {
          href: 'https://ge.wingie.com/fr/flights/tr-turkey/',
          title: 'Turquie',
        },
        {
          href: 'https://ge.wingie.com/fr/flights/ru-russia/',
          title: 'Russie',
        },
        {
          href: 'https://ge.wingie.com/fr/flights/az-azerbaijan/',
          title: 'Azerbaïdjan',
        },
        {
          href: 'https://ge.wingie.com/fr/flights/am-armenia/',
          title: 'Arménie',
        },
        {
          href: 'https://ge.wingie.com/fr/flights/ae-united-arab-emirates/',
          title: 'Émirats arabes unis',
        },
        {
          href: 'https://ge.wingie.com/fr/flights/de-germany/',
          title: 'Allemagne',
        },
      ],
    },
    {
      title: 'Compagnies aériennes populaires',
      items: [
        {
          href: 'https://ge.wingie.com/fr/flights/airlines/georgian-airways/',
          title: 'Georgian Airways',
        },
        {
          href: 'https://ge.wingie.com/fr/flights/airlines/turkish-airlines/',
          title: 'Turkish Airlines',
        },
        {
          href: 'https://ge.wingie.com/fr/flights/airlines/flydubai/',
          title: 'flydubai',
        },
        {
          href: 'https://ge.wingie.com/fr/flights/airlines/wizz-air/',
          title: 'Wizz Air',
        },
        {
          href: 'https://ge.wingie.com/fr/flights/airlines/pegasus/',
          title: 'Pegasus',
        },
        {
          href: 'https://ge.wingie.com/fr/flights/airlines/lufthansa/',
          title: 'Lufthansa',
        },
      ],
    },
  ],
  'ge-pt': [
    {
      title: 'Destinos principais',
      items: [
        {
          href: 'https://ge.wingie.com/pt/flights/to-tbilisi/',
          title: 'Tbilisi',
        },
        {
          href: 'https://ge.wingie.com/pt/flights/to-batumi/',
          title: 'Batumi',
        },
        {
          href: 'https://ge.wingie.com/pt/flights/to-kutaisi/',
          title: 'Kutaisi',
        },
        {
          href: 'https://ge.wingie.com/pt/flights/to-moscow/',
          title: 'Moscou',
        },
        {
          href: 'https://ge.wingie.com/pt/flights/to-istanbul/',
          title: 'Istambul',
        },
        {
          href: 'https://ge.wingie.com/pt/flights/to-baku/',
          title: 'Baku',
        },
      ],
    },
    {
      title: 'Países populares',
      items: [
        {
          href: 'https://ge.wingie.com/pt/flights/tr-turkey/',
          title: 'Turquia',
        },
        {
          href: 'https://ge.wingie.com/pt/flights/ru-russia/',
          title: 'Rússia',
        },
        {
          href: 'https://ge.wingie.com/pt/flights/az-azerbaijan/',
          title: 'Azerbaijão',
        },
        {
          href: 'https://ge.wingie.com/pt/flights/am-armenia/',
          title: 'Armênia',
        },
        {
          href: 'https://ge.wingie.com/pt/flights/ae-united-arab-emirates/',
          title: 'Emirados Árabes Unidos',
        },
        {
          href: 'https://ge.wingie.com/pt/flights/de-germany/',
          title: 'Alemanha',
        },
      ],
    },
    {
      title: 'Companhias aéreas populares',
      items: [
        {
          href: 'https://ge.wingie.com/pt/flights/airlines/georgian-airways/',
          title: 'Georgian Airways',
        },
        {
          href: 'https://ge.wingie.com/pt/flights/airlines/turkish-airlines/',
          title: 'Turkish Airlines',
        },
        {
          href: 'https://ge.wingie.com/pt/flights/airlines/flydubai/',
          title: 'flydubai',
        },
        {
          href: 'https://ge.wingie.com/pt/flights/airlines/wizz-air/',
          title: 'Wizz Air',
        },
        {
          href: 'https://ge.wingie.com/pt/flights/airlines/pegasus/',
          title: 'Pegasus',
        },
        {
          href: 'https://ge.wingie.com/pt/flights/airlines/lufthansa/',
          title: 'Lufthansa',
        },
      ],
    },
  ],
  'ge-ro': [
    {
      title: 'Destinații principale',
      items: [
        {
          href: 'https://ge.wingie.com/ro/flights/to-tbilisi/',
          title: 'Tbilisi',
        },
        {
          href: 'https://ge.wingie.com/ro/flights/to-batumi/',
          title: 'Batumi',
        },
        {
          href: 'https://ge.wingie.com/ro/flights/to-kutaisi/',
          title: 'Kutaisi',
        },
        {
          href: 'https://ge.wingie.com/ro/flights/to-moscow/',
          title: 'Moscova',
        },
        {
          href: 'https://ge.wingie.com/ro/flights/to-istanbul/',
          title: 'Istanbul',
        },
        {
          href: 'https://ge.wingie.com/ro/flights/to-baku/',
          title: 'Baku',
        },
      ],
    },
    {
      title: 'Țări populare',
      items: [
        {
          href: 'https://ge.wingie.com/ro/flights/tr-turkey/',
          title: 'Turcia',
        },
        {
          href: 'https://ge.wingie.com/ro/flights/ru-russia/',
          title: 'Rusia',
        },
        {
          href: 'https://ge.wingie.com/ro/flights/az-azerbaijan/',
          title: 'Azerbaidjan',
        },
        {
          href: 'https://ge.wingie.com/ro/flights/am-armenia/',
          title: 'Armenia',
        },
        {
          href: 'https://ge.wingie.com/ro/flights/ae-united-arab-emirates/',
          title: 'Emiratele Arabe Unite',
        },
        {
          href: 'https://ge.wingie.com/ro/flights/de-germany/',
          title: 'Germania',
        },
      ],
    },
    {
      title: 'Companii aeriene populare',
      items: [
        {
          href: 'https://ge.wingie.com/ro/flights/airlines/georgian-airways/',
          title: 'Georgian Airways',
        },
        {
          href: 'https://ge.wingie.com/ro/flights/airlines/turkish-airlines/',
          title: 'Turkish Airlines',
        },
        {
          href: 'https://ge.wingie.com/ro/flights/airlines/flydubai/',
          title: 'flydubai',
        },
        {
          href: 'https://ge.wingie.com/ro/flights/airlines/wizz-air/',
          title: 'Wizz Air',
        },
        {
          href: 'https://ge.wingie.com/ro/flights/airlines/pegasus/',
          title: 'Pegasus',
        },
        {
          href: 'https://ge.wingie.com/ro/flights/airlines/lufthansa/',
          title: 'Lufthansa',
        },
      ],
    },
  ],
  'ge-pl': [
    {
      title: 'Popularne kierunki',
      items: [
        {
          href: 'https://ge.wingie.com/pl/flights/to-tbilisi/',
          title: 'Tbilisi',
        },
        {
          href: 'https://ge.wingie.com/pl/flights/to-batumi/',
          title: 'Batumi',
        },
        {
          href: 'https://ge.wingie.com/pl/flights/to-kutaisi/',
          title: 'Kutaisi',
        },
        {
          href: 'https://ge.wingie.com/pl/flights/to-moscow/',
          title: 'Moskwa',
        },
        {
          href: 'https://ge.wingie.com/pl/flights/to-istanbul/',
          title: 'Stambuł',
        },
        {
          href: 'https://ge.wingie.com/pl/flights/to-baku/',
          title: 'Baku',
        },
      ],
    },
    {
      title: 'Popularne kraje',
      items: [
        {
          href: 'https://ge.wingie.com/pl/flights/tr-turkey/',
          title: 'Turcja',
        },
        {
          href: 'https://ge.wingie.com/pl/flights/ru-russia/',
          title: 'Rosja',
        },
        {
          href: 'https://ge.wingie.com/pl/flights/az-azerbaijan/',
          title: 'Azerbejdżan',
        },
        {
          href: 'https://ge.wingie.com/pl/flights/am-armenia/',
          title: 'Armenia',
        },
        {
          href: 'https://ge.wingie.com/pl/flights/ae-united-arab-emirates/',
          title: 'Zjednoczone Emiraty Arabskie',
        },
        {
          href: 'https://ge.wingie.com/pl/flights/de-germany/',
          title: 'Niemcy',
        },
      ],
    },
    {
      title: 'Popularne linie lotnicze',
      items: [
        {
          href: 'https://ge.wingie.com/pl/flights/airlines/georgian-airways/',
          title: 'Georgian Airways',
        },
        {
          href: 'https://ge.wingie.com/pl/flights/airlines/turkish-airlines/',
          title: 'Turkish Airlines',
        },
        {
          href: 'https://ge.wingie.com/pl/flights/airlines/flydubai/',
          title: 'flydubai',
        },
        {
          href: 'https://ge.wingie.com/pl/flights/airlines/wizz-air/',
          title: 'Wizz Air',
        },
        {
          href: 'https://ge.wingie.com/pl/flights/airlines/pegasus/',
          title: 'Pegasus',
        },
        {
          href: 'https://ge.wingie.com/pl/flights/airlines/lufthansa/',
          title: 'Lufthansa',
        },
      ],
    },
  ],
  'ge-lt': [
    {
      title: 'Populiarūs kryptys',
      items: [
        {
          href: 'https://ge.wingie.com/lt/flights/to-tbilisi/',
          title: 'Tbilisis',
        },
        {
          href: 'https://ge.wingie.com/lt/flights/to-batumi/',
          title: 'Batumis',
        },
        {
          href: 'https://ge.wingie.com/lt/flights/to-kutaisi/',
          title: 'Kutaisis',
        },
        {
          href: 'https://ge.wingie.com/lt/flights/to-moscow/',
          title: 'Maskva',
        },
        {
          href: 'https://ge.wingie.com/lt/flights/to-istanbul/',
          title: 'Stambulas',
        },
        {
          href: 'https://ge.wingie.com/lt/flights/to-baku/',
          title: 'Baku',
        },
      ],
    },
    {
      title: 'Populiarios šalys',
      items: [
        {
          href: 'https://ge.wingie.com/lt/flights/tr-turkey/',
          title: 'Turkija',
        },
        {
          href: 'https://ge.wingie.com/lt/flights/ru-russia/',
          title: 'Rusija',
        },
        {
          href: 'https://ge.wingie.com/lt/flights/az-azerbaijan/',
          title: 'Azerbaidžanas',
        },
        {
          href: 'https://ge.wingie.com/lt/flights/am-armenia/',
          title: 'Armėnija',
        },
        {
          href: 'https://ge.wingie.com/lt/flights/ae-united-arab-emirates/',
          title: 'Jungtiniai Arabų Emyratai',
        },
        {
          href: 'https://ge.wingie.com/lt/flights/de-germany/',
          title: 'Vokietija',
        },
      ],
    },
    {
      title: 'Populiarūs oro vežėjai',
      items: [
        {
          href: 'https://ge.wingie.com/lt/flights/airlines/georgian-airways/',
          title: 'Georgian Airways',
        },
        {
          href: 'https://ge.wingie.com/lt/flights/airlines/turkish-airlines/',
          title: 'Turkish Airlines',
        },
        {
          href: 'https://ge.wingie.com/lt/flights/airlines/flydubai/',
          title: 'flydubai',
        },
        {
          href: 'https://ge.wingie.com/lt/flights/airlines/wizz-air/',
          title: 'Wizz Air',
        },
        {
          href: 'https://ge.wingie.com/lt/flights/airlines/pegasus/',
          title: 'Pegasus',
        },
        {
          href: 'https://ge.wingie.com/lt/flights/airlines/lufthansa/',
          title: 'Lufthansa',
        },
      ],
    },
  ],
  'ge-uz': [
    {
      title: "Mashhur yo'nalishlar",
      items: [
        {
          href: 'https://ge.wingie.com/uz/flights/to-tbilisi/',
          title: 'Tbilisi',
        },
        {
          href: 'https://ge.wingie.com/uz/flights/to-batumi/',
          title: 'Batumi',
        },
        {
          href: 'https://ge.wingie.com/uz/flights/to-kutaisi/',
          title: 'Kutaisi',
        },
        {
          href: 'https://ge.wingie.com/uz/flights/to-moscow/',
          title: 'Moskva',
        },
        {
          href: 'https://ge.wingie.com/uz/flights/to-istanbul/',
          title: 'Istanbul',
        },
        {
          href: 'https://ge.wingie.com/uz/flights/to-baku/',
          title: 'Baku',
        },
      ],
    },
    {
      title: 'Mashhur mamlakatlar',
      items: [
        {
          href: 'https://ge.wingie.com/uz/flights/tr-turkey/',
          title: 'Turkiya',
        },
        {
          href: 'https://ge.wingie.com/uz/flights/ru-russia/',
          title: 'Rossiya',
        },
        {
          href: 'https://ge.wingie.com/uz/flights/az-azerbaijan/',
          title: 'Ozarbayjon',
        },
        {
          href: 'https://ge.wingie.com/uz/flights/am-armenia/',
          title: 'Armaniston',
        },
        {
          href: 'https://ge.wingie.com/uz/flights/ae-united-arab-emirates/',
          title: 'Birlashgan Arab Amirliklari',
        },
        {
          href: 'https://ge.wingie.com/uz/flights/de-germany/',
          title: 'Germaniya',
        },
      ],
    },
    {
      title: 'Mashhur aviakompaniyalar',
      items: [
        {
          href: 'https://ge.wingie.com/uz/flights/airlines/georgian-airways/',
          title: 'Georgian Airways',
        },
        {
          href: 'https://ge.wingie.com/uz/flights/airlines/turkish-airlines/',
          title: 'Turkish Airlines',
        },
        {
          href: 'https://ge.wingie.com/uz/flights/airlines/flydubai/',
          title: 'flydubai',
        },
        {
          href: 'https://ge.wingie.com/uz/flights/airlines/wizz-air/',
          title: 'Wizz Air',
        },
        {
          href: 'https://ge.wingie.com/uz/flights/airlines/pegasus/',
          title: 'Pegasus',
        },
        {
          href: 'https://ge.wingie.com/uz/flights/airlines/lufthansa/',
          title: 'Lufthansa',
        },
      ],
    },
  ],
  'ge-sr': [
    {
      title: 'Популарне дестинације',
      items: [
        {
          href: 'https://ge.wingie.com/sr/flights/to-tbilisi/',
          title: 'Тбилиси',
        },
        {
          href: 'https://ge.wingie.com/sr/flights/to-batumi/',
          title: 'Батуми',
        },
        {
          href: 'https://ge.wingie.com/sr/flights/to-kutaisi/',
          title: 'Кутаиси',
        },
        {
          href: 'https://ge.wingie.com/sr/flights/to-moscow/',
          title: 'Москва',
        },
        {
          href: 'https://ge.wingie.com/sr/flights/to-istanbul/',
          title: 'Истанбул',
        },
        {
          href: 'https://ge.wingie.com/sr/flights/to-baku/',
          title: 'Бакиу',
        },
      ],
    },
    {
      title: 'Популарне земље',
      items: [
        {
          href: 'https://ge.wingie.com/sr/flights/tr-turkey/',
          title: 'Турска',
        },
        {
          href: 'https://ge.wingie.com/sr/flights/ru-russia/',
          title: 'Русија',
        },
        {
          href: 'https://ge.wingie.com/sr/flights/az-azerbaijan/',
          title: 'Азербејџан',
        },
        {
          href: 'https://ge.wingie.com/sr/flights/am-armenia/',
          title: 'Јерменија',
        },
        {
          href: 'https://ge.wingie.com/sr/flights/ae-united-arab-emirates/',
          title: 'Уједињени Арапски Емирати',
        },
        {
          href: 'https://ge.wingie.com/sr/flights/de-germany/',
          title: 'Немачка',
        },
      ],
    },
    {
      title: 'Популарне авио-компаније',
      items: [
        {
          href: 'https://ge.wingie.com/sr/flights/airlines/georgian-airways/',
          title: 'Georgian Airways',
        },
        {
          href: 'https://ge.wingie.com/sr/flights/airlines/turkish-airlines/',
          title: 'Turkish Airlines',
        },
        {
          href: 'https://ge.wingie.com/sr/flights/airlines/flydubai/',
          title: 'flydubai',
        },
        {
          href: 'https://ge.wingie.com/sr/flights/airlines/wizz-air/',
          title: 'Wizz Air',
        },
        {
          href: 'https://ge.wingie.com/sr/flights/airlines/pegasus/',
          title: 'Pegasus',
        },
        {
          href: 'https://ge.wingie.com/sr/flights/airlines/lufthansa/',
          title: 'Lufthansa',
        },
      ],
    },
  ],
  'ge-ky': [
    {
      title: 'Популярдуу багыттар',
      items: [
        {
          href: 'https://ge.wingie.com/ky/flights/to-tbilisi/',
          title: 'Тбилиси',
        },
        {
          href: 'https://ge.wingie.com/ky/flights/to-batumi/',
          title: 'Батуми',
        },
        {
          href: 'https://ge.wingie.com/ky/flights/to-kutaisi/',
          title: 'Кутаиси',
        },
        {
          href: 'https://ge.wingie.com/ky/flights/to-moscow/',
          title: 'Москва',
        },
        {
          href: 'https://ge.wingie.com/ky/flights/to-istanbul/',
          title: 'Стамбул',
        },
        {
          href: 'https://ge.wingie.com/ky/flights/to-baku/',
          title: 'Баку',
        },
      ],
    },
    {
      title: 'Популярдуу өлкөлөр',
      items: [
        {
          href: 'https://ge.wingie.com/ky/flights/tr-turkey/',
          title: 'Түркия',
        },
        {
          href: 'https://ge.wingie.com/ky/flights/ru-russia/',
          title: 'Россия',
        },
        {
          href: 'https://ge.wingie.com/ky/flights/az-azerbaijan/',
          title: 'Азербайжан',
        },
        {
          href: 'https://ge.wingie.com/ky/flights/am-armenia/',
          title: 'Армения',
        },
        {
          href: 'https://ge.wingie.com/ky/flights/ae-united-arab-emirates/',
          title: 'Бириккен Араб Эмиратары',
        },
        {
          href: 'https://ge.wingie.com/ky/flights/de-germany/',
          title: 'Германия',
        },
      ],
    },
    {
      title: 'Популярдуу авиакомпаниялар',
      items: [
        {
          href: 'https://ge.wingie.com/ky/flights/airlines/georgian-airways/',
          title: 'Georgian Airways',
        },
        {
          href: 'https://ge.wingie.com/ky/flights/airlines/turkish-airlines/',
          title: 'Turkish Airlines',
        },
        {
          href: 'https://ge.wingie.com/ky/flights/airlines/flydubai/',
          title: 'flydubai',
        },
        {
          href: 'https://ge.wingie.com/ky/flights/airlines/wizz-air/',
          title: 'Wizz Air',
        },
        {
          href: 'https://ge.wingie.com/ky/flights/airlines/pegasus/',
          title: 'Pegasus',
        },
        {
          href: 'https://ge.wingie.com/ky/flights/airlines/lufthansa/',
          title: 'Lufthansa',
        },
      ],
    },
  ],
  'ge-tg': [
    {
      title: 'Самтҳои маъмул',
      items: [
        {
          href: 'https://ge.wingie.com/tg/flights/to-tbilisi/',
          title: 'Тбилиси',
        },
        {
          href: 'https://ge.wingie.com/tg/flights/to-batumi/',
          title: 'Батуми',
        },
        {
          href: 'https://ge.wingie.com/tg/flights/to-kutaisi/',
          title: 'Кутаиси',
        },
        {
          href: 'https://ge.wingie.com/tg/flights/to-moscow/',
          title: 'Маскав',
        },
        {
          href: 'https://ge.wingie.com/tg/flights/to-istanbul/',
          title: 'Истанбул',
        },
        {
          href: 'https://ge.wingie.com/tg/flights/to-baku/',
          title: 'Баку',
        },
      ],
    },
    {
      title: 'Кишварҳои маъмул',
      items: [
        {
          href: 'https://ge.wingie.com/tg/flights/tr-turkey/',
          title: 'Туркия',
        },
        {
          href: 'https://ge.wingie.com/tg/flights/ru-russia/',
          title: 'Русия',
        },
        {
          href: 'https://ge.wingie.com/tg/flights/az-azerbaijan/',
          title: 'Озарбойҷон',
        },
        {
          href: 'https://ge.wingie.com/tg/flights/am-armenia/',
          title: 'Арманистон',
        },
        {
          href: 'https://ge.wingie.com/tg/flights/ae-united-arab-emirates/',
          title: 'Аморати Муттаҳидаи Араб',
        },
        {
          href: 'https://ge.wingie.com/tg/flights/de-germany/',
          title: 'Олмон',
        },
      ],
    },
    {
      title: 'Ширкатҳои маъмули ҳавопаймоӣ',
      items: [
        {
          href: 'https://ge.wingie.com/tg/flights/airlines/georgian-airways/',
          title: 'Georgian Airways',
        },
        {
          href: 'https://ge.wingie.com/tg/flights/airlines/turkish-airlines/',
          title: 'Turkish Airlines',
        },
        {
          href: 'https://ge.wingie.com/tg/flights/airlines/flydubai/',
          title: 'flydubai',
        },
        {
          href: 'https://ge.wingie.com/tg/flights/airlines/wizz-air/',
          title: 'Wizz Air',
        },
        {
          href: 'https://ge.wingie.com/tg/flights/airlines/pegasus/',
          title: 'Pegasus',
        },
        {
          href: 'https://ge.wingie.com/tg/flights/airlines/lufthansa/',
          title: 'Lufthansa',
        },
      ],
    },
  ],
  'ge-kk': [
    {
      title: 'Танымал бағыттар',
      items: [
        {
          href: 'https://ge.wingie.com/kk/flights/to-tbilisi/',
          title: 'Тбилиси',
        },
        {
          href: 'https://ge.wingie.com/kk/flights/to-batumi/',
          title: 'Батуми',
        },
        {
          href: 'https://ge.wingie.com/kk/flights/to-kutaisi/',
          title: 'Кутаиси',
        },
        {
          href: 'https://ge.wingie.com/kk/flights/to-moscow/',
          title: 'Мәскеу',
        },
        {
          href: 'https://ge.wingie.com/kk/flights/to-istanbul/',
          title: 'Стамбул',
        },
        {
          href: 'https://ge.wingie.com/kk/flights/to-baku/',
          title: 'Баку',
        },
      ],
    },
    {
      title: 'Танымал елдер',
      items: [
        {
          href: 'https://ge.wingie.com/kk/flights/tr-turkey/',
          title: 'Түркия',
        },
        {
          href: 'https://ge.wingie.com/kk/flights/ru-russia/',
          title: 'Ресей',
        },
        {
          href: 'https://ge.wingie.com/kk/flights/az-azerbaijan/',
          title: 'Әзербайжан',
        },
        {
          href: 'https://ge.wingie.com/kk/flights/am-armenia/',
          title: 'Армения',
        },
        {
          href: 'https://ge.wingie.com/kk/flights/ae-united-arab-emirates/',
          title: 'Біріккен Араб Әмірліктері',
        },
        {
          href: 'https://ge.wingie.com/kk/flights/de-germany/',
          title: 'Германия',
        },
      ],
    },
    {
      title: 'Танымал авиакомпаниялар',
      items: [
        {
          href: 'https://ge.wingie.com/kk/flights/airlines/georgian-airways/',
          title: 'Georgian Airways',
        },
        {
          href: 'https://ge.wingie.com/kk/flights/airlines/turkish-airlines/',
          title: 'Turkish Airlines',
        },
        {
          href: 'https://ge.wingie.com/kk/flights/airlines/flydubai/',
          title: 'flydubai',
        },
        {
          href: 'https://ge.wingie.com/kk/flights/airlines/wizz-air/',
          title: 'Wizz Air',
        },
        {
          href: 'https://ge.wingie.com/kk/flights/airlines/pegasus/',
          title: 'Pegasus',
        },
        {
          href: 'https://ge.wingie.com/kk/flights/airlines/lufthansa/',
          title: 'Lufthansa',
        },
      ],
    },
  ],
  'ge-nl': [
    {
      title: 'Populaire bestemmingen',
      items: [
        {
          href: 'https://ge.wingie.com/nl/flights/to-tbilisi/',
          title: 'Tbilisi',
        },
        {
          href: 'https://ge.wingie.com/nl/flights/to-batumi/',
          title: 'Batumi',
        },
        {
          href: 'https://ge.wingie.com/nl/flights/to-kutaisi/',
          title: 'Kutaisi',
        },
        {
          href: 'https://ge.wingie.com/nl/flights/to-moscow/',
          title: 'Moskou',
        },
        {
          href: 'https://ge.wingie.com/nl/flights/to-istanbul/',
          title: 'Istanbul',
        },
        {
          href: 'https://ge.wingie.com/nl/flights/to-baku/',
          title: 'Baku',
        },
      ],
    },
    {
      title: 'Populaire landen',
      items: [
        {
          href: 'https://ge.wingie.com/nl/flights/tr-turkey/',
          title: 'Turkije',
        },
        {
          href: 'https://ge.wingie.com/nl/flights/ru-russia/',
          title: 'Rusland',
        },
        {
          href: 'https://ge.wingie.com/nl/flights/az-azerbaijan/',
          title: 'Azerbeidzjan',
        },
        {
          href: 'https://ge.wingie.com/nl/flights/am-armenia/',
          title: 'Armenië',
        },
        {
          href: 'https://ge.wingie.com/nl/flights/ae-united-arab-emirates/',
          title: 'Verenigde Arabische Emiraten',
        },
        {
          href: 'https://ge.wingie.com/nl/flights/de-germany/',
          title: 'Duitsland',
        },
      ],
    },
    {
      title: 'Populaire luchtvaartmaatschappijen',
      items: [
        {
          href: 'https://ge.wingie.com/nl/flights/airlines/georgian-airways/',
          title: 'Georgian Airways',
        },
        {
          href: 'https://ge.wingie.com/nl/flights/airlines/turkish-airlines/',
          title: 'Turkish Airlines',
        },
        {
          href: 'https://ge.wingie.com/nl/flights/airlines/flydubai/',
          title: 'flydubai',
        },
        {
          href: 'https://ge.wingie.com/nl/flights/airlines/wizz-air/',
          title: 'Wizz Air',
        },
        {
          href: 'https://ge.wingie.com/nl/flights/airlines/pegasus/',
          title: 'Pegasus',
        },
        {
          href: 'https://ge.wingie.com/nl/flights/airlines/lufthansa/',
          title: 'Lufthansa',
        },
      ],
    },
  ],
    'ge-ja': [
        {
            title: '人気の目的地',
            items: [
                { title: 'ラスベガス', href: 'https://ge.wingie.com/ja/flights/to-las-vegas/' },
                { title: 'シカゴ', href: 'https://ge.wingie.com/ja/flights/to-chicago/' },
                { title: 'マイアミ', href: 'https://ge.wingie.com/ja/flights/to-miami/' },
                { title: 'カンクン', href: 'https://ge.wingie.com/ja/flights/to-cancun/' },
                { title: 'ロンドン', href: 'https://ge.wingie.com/ja/flights/to-london/' },
                { title: 'ホノルル', href: 'https://ge.wingie.com/ja/flights/to-honolulu/' },
            ],
        },
        {
            title: '人気の国',
            items: [
                { title: 'カナダ', href: 'https://ge.wingie.com/ja/flights/ca-canada/' },
                { title: '中国', href: 'https://ge.wingie.com/ja/flights/cn-china/' },
                { title: 'コスタリカ', href: 'https://ge.wingie.com/ja/flights/cr-costa-rica/' },
                { title: 'ドミニカ共和国', href: 'https://ge.wingie.com/ja/flights/do-dominican-republic/' },
                { title: 'エルサルバドル', href: 'https://ge.wingie.com/ja/flights/sv-el-salvador/' },
                { title: 'フランス', href: 'https://ge.wingie.com/ja/flights/fr-france/' },
            ],
        },
        {
            title: '人気の航空会社',
            items: [
                { title: 'アメリカン・エアラインズ', href: 'https://ge.wingie.com/ja/flights/airlines/american-airlines/' },
                { title: 'デルタ航空', href: 'https://ge.wingie.com/ja/flights/airlines/delta-air-lines/' },
                { title: 'ユナイテッド航空', href: 'https://ge.wingie.com/ja/flights/airlines/united-airlines/' },
                { title: 'アラスカ航空', href: 'https://ge.wingie.com/ja/flights/airlines/alaska-airlines/' },
                { title: 'JetBlue', href: 'https://ge.wingie.com/ja/flights/airlines/jetblue/' },
                { title: 'ハワイアン航空', href: 'https://ge.wingie.com/ja/flights/airlines/hawaiian-airlines/' },
            ],
        },
    ],
    'ge-zh': [
        {
            title: '热门目的地',
            items: [
                { title: '拉斯维加斯', href: 'https://ge.wingie.com/zh/flights/to-las-vegas/' },
                { title: '芝加哥', href: 'https://ge.wingie.com/zh/flights/to-chicago/' },
                { title: '迈阿密', href: 'https://ge.wingie.com/zh/flights/to-miami/' },
                { title: '坎昆', href: 'https://ge.wingie.com/zh/flights/to-cancun/' },
                { title: '伦敦', href: 'https://ge.wingie.com/zh/flights/to-london/' },
                { title: '火奴鲁鲁', href: 'https://ge.wingie.com/zh/flights/to-honolulu/' },
            ],
        },
        {
            title: '热门国家',
            items: [
                { title: '加拿大', href: 'https://ge.wingie.com/zh/flights/ca-canada/' },
                { title: '中国', href: 'https://ge.wingie.com/zh/flights/cn-china/' },
                { title: '哥斯达黎加', href: 'https://ge.wingie.com/zh/flights/cr-costa-rica/' },
                { title: '多米尼加共和国', href: 'https://ge.wingie.com/zh/flights/do-dominican-republic/' },
                { title: '萨尔瓦多', href: 'https://ge.wingie.com/zh/flights/sv-el-salvador/' },
                { title: '法国', href: 'https://ge.wingie.com/zh/flights/fr-france/' },
            ],
        },
        {
            title: '热门航空公司',
            items: [
                { title: '美国航空', href: 'https://ge.wingie.com/zh/flights/airlines/american-airlines/' },
                { title: '达美航空', href: 'https://ge.wingie.com/zh/flights/airlines/delta-air-lines/' },
                { title: '美联航', href: 'https://ge.wingie.com/zh/flights/airlines/united-airlines/' },
                { title: '阿拉斯加航空', href: 'https://ge.wingie.com/zh/flights/airlines/alaska-airlines/' },
                { title: 'JetBlue', href: 'https://ge.wingie.com/zh/flights/airlines/jetblue/' },
                { title: '夏威夷航空', href: 'https://ge.wingie.com/zh/flights/airlines/hawaiian-airlines/' },
            ],
        },
    ],
    'ge-ko': [
        {
            title: '인기 목적지',
            items: [
                { title: '라스베이거스', href: 'https://ge.wingie.com/ko/flights/to-las-vegas/' },
                { title: '시카고', href: 'https://ge.wingie.com/ko/flights/to-chicago/' },
                { title: '마이애미', href: 'https://ge.wingie.com/ko/flights/to-miami/' },
                { title: '칸쿤', href: 'https://ge.wingie.com/ko/flights/to-cancun/' },
                { title: '런던', href: 'https://ge.wingie.com/ko/flights/to-london/' },
                { title: '호놀룰루', href: 'https://ge.wingie.com/ko/flights/to-honolulu/' },
            ],
        },
        {
            title: '인기 국가',
            items: [
                { title: '캐나다', href: 'https://ge.wingie.com/ko/flights/ca-canada/' },
                { title: '중국', href: 'https://ge.wingie.com/ko/flights/cn-china/' },
                { title: '코스타리카', href: 'https://ge.wingie.com/ko/flights/cr-costa-rica/' },
                { title: '도미니카 공화국', href: 'https://ge.wingie.com/ko/flights/do-dominican-republic/' },
                { title: '엘살바도르', href: 'https://ge.wingie.com/ko/flights/sv-el-salvador/' },
                { title: '프랑스', href: 'https://ge.wingie.com/ko/flights/fr-france/' },
            ],
        },
        {
            title: '인기 항공사',
            items: [
                { title: '아메리칸 항공', href: 'https://ge.wingie.com/ko/flights/airlines/american-airlines/' },
                { title: '델타 항공', href: 'https://ge.wingie.com/ko/flights/airlines/delta-air-lines/' },
                { title: '유나이티드 항공', href: 'https://ge.wingie.com/ko/flights/airlines/united-airlines/' },
                { title: '알래스카 항공', href: 'https://ge.wingie.com/ko/flights/airlines/alaska-airlines/' },
                { title: 'JetBlue', href: 'https://ge.wingie.com/ko/flights/airlines/jetblue/' },
                { title: '하와이안 항공', href: 'https://ge.wingie.com/ko/flights/airlines/hawaiian-airlines/' },
            ],
        },
    ],
    'ge-hi': [
        {
            title: 'लोकप्रिय गंतव्य',
            items: [
                { title: 'लास वेगास', href: 'https://ge.wingie.com/hi/flights/to-las-vegas/' },
                { title: 'शिकागो', href: 'https://ge.wingie.com/hi/flights/to-chicago/' },
                { title: 'मियामी', href: 'https://ge.wingie.com/hi/flights/to-miami/' },
                { title: 'कैनकन', href: 'https://ge.wingie.com/hi/flights/to-cancun/' },
                { title: 'लंदन', href: 'https://ge.wingie.com/hi/flights/to-london/' },
                { title: 'होनोलुलु', href: 'https://ge.wingie.com/hi/flights/to-honolulu/' },
            ],
        },
        {
            title: 'लोकप्रिय देश',
            items: [
                { title: 'कनाडा', href: 'https://ge.wingie.com/hi/flights/ca-canada/' },
                { title: 'चीन', href: 'https://ge.wingie.com/hi/flights/cn-china/' },
                { title: 'कोस्टा रिका', href: 'https://ge.wingie.com/hi/flights/cr-costa-rica/' },
                { title: 'डोमिनिकन गणराज्य', href: 'https://ge.wingie.com/hi/flights/do-dominican-republic/' },
                { title: 'अल सल्वाडोर', href: 'https://ge.wingie.com/hi/flights/sv-el-salvador/' },
                { title: 'फ्रांस', href: 'https://ge.wingie.com/hi/flights/fr-france/' },
            ],
        },
        {
            title: 'लोकप्रिय एयरलाइनें',
            items: [
                { title: 'अमेरिकन एयरलाइन्स', href: 'https://ge.wingie.com/hi/flights/airlines/american-airlines/' },
                { title: 'डेल्टा एयरलाइन्स', href: 'https://ge.wingie.com/hi/flights/airlines/delta-air-lines/' },
                { title: 'यूनाइटेड एयरलाइन्स', href: 'https://ge.wingie.com/hi/flights/airlines/united-airlines/' },
                { title: 'अलास्का एयरलाइन्स', href: 'https://ge.wingie.com/hi/flights/airlines/alaska-airlines/' },
                { title: 'JetBlue', href: 'https://ge.wingie.com/hi/flights/airlines/jetblue/' },
                { title: 'हवाई एयरलाइन्स', href: 'https://ge.wingie.com/hi/flights/airlines/hawaiian-airlines/' },
            ],
        },
    ],
    'ge-ta': [
        {
            title: 'பிரபலமான இலக்குகள்',
            items: [
                { title: 'லாஸ் வெகாஸ்', href: 'https://ge.wingie.com/ta/flights/to-las-vegas/' },
                { title: 'சிகாகோ', href: 'https://ge.wingie.com/ta/flights/to-chicago/' },
                { title: 'மியாமி', href: 'https://ge.wingie.com/ta/flights/to-miami/' },
                { title: 'கான்கன்', href: 'https://ge.wingie.com/ta/flights/to-cancun/' },
                { title: 'லண்டன்', href: 'https://ge.wingie.com/ta/flights/to-london/' },
                { title: 'ஓனோலுலு', href: 'https://ge.wingie.com/ta/flights/to-honolulu/' },
            ],
        },
        {
            title: 'பிரபலமான நாடுகள்',
            items: [
                { title: 'கனடா', href: 'https://ge.wingie.com/ta/flights/ca-canada/' },
                { title: 'சீனா', href: 'https://ge.wingie.com/ta/flights/cn-china/' },
                { title: 'கோஸ்டா ரிக்கா', href: 'https://ge.wingie.com/ta/flights/cr-costa-rica/' },
                { title: 'டொமினிக்கன் குடியரசு', href: 'https://ge.wingie.com/ta/flights/do-dominican-republic/' },
                { title: 'எல் சால்வடோர்', href: 'https://ge.wingie.com/ta/flights/sv-el-salvador/' },
                { title: 'பிரான்சு', href: 'https://ge.wingie.com/ta/flights/fr-france/' },
            ],
        },
        {
            title: 'பிரபலமான விமான நிறுவனங்கள்',
            items: [
                { title: 'அமெரிக்கன் ஏர்லைன்ஸ்', href: 'https://ge.wingie.com/ta/flights/airlines/american-airlines/' },
                { title: 'டெல்டா ஏர்லைன்ஸ்', href: 'https://ge.wingie.com/ta/flights/airlines/delta-air-lines/' },
                { title: 'யுனைட்டட் ஏர்லைன்ஸ்', href: 'https://ge.wingie.com/ta/flights/airlines/united-airlines/' },
                { title: 'அலாஸ்கா ஏர்லைன்ஸ்', href: 'https://ge.wingie.com/ta/flights/airlines/alaska-airlines/' },
                { title: 'JetBlue', href: 'https://ge.wingie.com/ta/flights/airlines/jetblue/' },
                { title: 'ஹவாய் ஏர்லைன்ஸ்', href: 'https://ge.wingie.com/ta/flights/airlines/hawaiian-airlines/' },
            ],
        },
    ],
    'ge-th': [
        {
            title: 'จุดหมายยอดนิยม',
            items: [
                { title: 'ลาสเวกัส', href: 'https://ge.wingie.com/th/flights/to-las-vegas/' },
                { title: 'ชิคาโก', href: 'https://ge.wingie.com/th/flights/to-chicago/' },
                { title: 'ไมอามี', href: 'https://ge.wingie.com/th/flights/to-miami/' },
                { title: 'แคนคูน', href: 'https://ge.wingie.com/th/flights/to-cancun/' },
                { title: 'ลอนดอน', href: 'https://ge.wingie.com/th/flights/to-london/' },
                { title: 'โฮโนลูลู', href: 'https://ge.wingie.com/th/flights/to-honolulu/' },
            ],
        },
        {
            title: 'ประเทศยอดนิยม',
            items: [
                { title: 'แคนาดา', href: 'https://ge.wingie.com/th/flights/ca-canada/' },
                { title: 'จีน', href: 'https://ge.wingie.com/th/flights/cn-china/' },
                { title: 'คอสตาริกา', href: 'https://ge.wingie.com/th/flights/cr-costa-rica/' },
                { title: 'สาธารณรัฐโดมินิกัน', href: 'https://ge.wingie.com/th/flights/do-dominican-republic/' },
                { title: 'เอลซัลวาดอร์', href: 'https://ge.wingie.com/th/flights/sv-el-salvador/' },
                { title: 'ฝรั่งเศส', href: 'https://ge.wingie.com/th/flights/fr-france/' },
            ],
        },
        {
            title: 'สายการบินยอดนิยม',
            items: [
                { title: 'อเมริกันแอร์ไลน์', href: 'https://ge.wingie.com/th/flights/airlines/american-airlines/' },
                { title: 'เดลต้า แอร์ไลน์', href: 'https://ge.wingie.com/th/flights/airlines/delta-air-lines/' },
                { title: 'ยูไนเต็ด แอร์ไลน์', href: 'https://ge.wingie.com/th/flights/airlines/united-airlines/' },
                { title: 'อลาสก้าแอร์ไลน์', href: 'https://ge.wingie.com/th/flights/airlines/alaska-airlines/' },
                { title: 'JetBlue', href: 'https://ge.wingie.com/th/flights/airlines/jetblue/' },
                { title: 'ฮาวายแอนแอร์ไลน์', href: 'https://ge.wingie.com/th/flights/airlines/hawaiian-airlines/' },
            ],
        },
    ],
    'ge-ur': [
        {
            title: 'مشہور منزلیں',
            items: [
                { title: 'لاس ویگاس', href: 'https://ge.wingie.com/ur/flights/to-las-vegas/' },
                { title: 'شکاگو', href: 'https://ge.wingie.com/ur/flights/to-chicago/' },
                { title: 'میامی', href: 'https://ge.wingie.com/ur/flights/to-miami/' },
                { title: 'کینکن', href: 'https://ge.wingie.com/ur/flights/to-cancun/' },
                { title: 'لندن', href: 'https://ge.wingie.com/ur/flights/to-london/' },
                { title: 'ہونولولو', href: 'https://ge.wingie.com/ur/flights/to-honolulu/' },
            ],
        },
        {
            title: 'مشہور ممالک',
            items: [
                { title: 'کینیڈا', href: 'https://ge.wingie.com/ur/flights/ca-canada/' },
                { title: 'چین', href: 'https://ge.wingie.com/ur/flights/cn-china/' },
                { title: 'کوسٹا ریکا', href: 'https://ge.wingie.com/ur/flights/cr-costa-rica/' },
                { title: 'ڈومینیکن جمہوریہ', href: 'https://ge.wingie.com/ur/flights/do-dominican-republic/' },
                { title: 'ایل سیلواڈور', href: 'https://ge.wingie.com/ur/flights/sv-el-salvador/' },
                { title: 'فرانس', href: 'https://ge.wingie.com/ur/flights/fr-france/' },
            ],
        },
        {
            title: 'مشہور ایئر لائنز',
            items: [
                { title: 'امریکن ایئرلائنز', href: 'https://ge.wingie.com/ur/flights/airlines/american-airlines/' },
                { title: 'ڈیلٹا ایئر لائنز', href: 'https://ge.wingie.com/ur/flights/airlines/delta-air-lines/' },
                { title: 'یونائیٹڈ ایئرلائنز', href: 'https://ge.wingie.com/ur/flights/airlines/united-airlines/' },
                { title: 'الاسکا ایئرلائنز', href: 'https://ge.wingie.com/ur/flights/airlines/alaska-airlines/' },
                { title: 'JetBlue', href: 'https://ge.wingie.com/ur/flights/airlines/jetblue/' },
                { title: 'ہوائی ایئرلائنز', href: 'https://ge.wingie.com/ur/flights/airlines/hawaiian-airlines/' },
            ],
        },
    ],
    'ge-ka': [
        {
            title: 'პოპულარული მიმართულებები',
            items: [
                { title: 'ლას-ვეგასი', href: 'https://ge.wingie.com/ka/flights/to-las-vegas/' },
                { title: 'ჩიკაგო', href: 'https://ge.wingie.com/ka/flights/to-chicago/' },
                { title: 'მაიამი', href: 'https://ge.wingie.com/ka/flights/to-miami/' },
                { title: 'კანკუნი', href: 'https://ge.wingie.com/ka/flights/to-cancun/' },
                { title: 'ლონდონი', href: 'https://ge.wingie.com/ka/flights/to-london/' },
                { title: 'ჰონოლულუ', href: 'https://ge.wingie.com/ka/flights/to-honolulu/' },
            ],
        },
        {
            title: 'პოპულარული ქვეყნები',
            items: [
                { title: 'კანადა', href: 'https://ge.wingie.com/ka/flights/ca-canada/' },
                { title: 'ჩინეთი', href: 'https://ge.wingie.com/ka/flights/cn-china/' },
                { title: 'კოსტა-რიკა', href: 'https://ge.wingie.com/ka/flights/cr-costa-rica/' },
                { title: 'დომინიკელთა რესპუბლიკა', href: 'https://ge.wingie.com/ka/flights/do-dominican-republic/' },
                { title: 'სალვადორი', href: 'https://ge.wingie.com/ka/flights/sv-el-salvador/' },
                { title: 'საფრანგეთი', href: 'https://ge.wingie.com/ka/flights/fr-france/' },
            ],
        },
        {
            title: 'პოპულარული ავიაკომპანიები',
            items: [
                { title: 'ამერიკის ავიაკომპანია', href: 'https://ge.wingie.com/ka/flights/airlines/american-airlines/' },
                { title: 'დელტა ეარ ლაინზი', href: 'https://ge.wingie.com/ka/flights/airlines/delta-air-lines/' },
                { title: 'იუნაიტედ ერლაინზი', href: 'https://ge.wingie.com/ka/flights/airlines/united-airlines/' },
                { title: 'ალასკას ავიაკომპანია', href: 'https://ge.wingie.com/ka/flights/airlines/alaska-airlines/' },
                { title: 'JetBlue', href: 'https://ge.wingie.com/ka/flights/airlines/jetblue/' },
                { title: 'ჰავაუს ავიაკომპანია', href: 'https://ge.wingie.com/ka/flights/airlines/hawaiian-airlines/' },
            ],
        },
    ]
}